import { ElInput as i } from "element-plus";
import { resolveComponent as a, openBlock as u, createElementBlock as l, createVNode as f, mergeProps as d, toHandlers as m, createSlots as c, withCtx as n, renderSlot as t } from "vue";
import { _ as $ } from "../_plugin-vue_export-helper-dad06003.js";
import { w as I } from "../util-b2b0dc25.js";
const h = {
  name: "rInput",
  components: {
    ElInput: i
  },
  data() {
    return {
      formSize: this.size === "default" || !this.size ? "" : "small"
    };
  },
  methods: {
    onInputChange(e) {
      this.$emit("input", e);
    }
  },
  props: {
    /**
     * 通过v-model直接绑定
     */
    value: [String, Number],
    /**
     * 输入框尺寸，只在 type!="textarea" 时有效
     */
    size: {
      type: String,
      default: "default"
    }
  }
}, v = { class: "r-input-wrap" };
function k(e, g, s, S, o, p) {
  const r = a("ElInput");
  return u(), l("div", v, [
    f(r, d(e.$attrs, m(e.$listeners), {
      value: s.value,
      size: o.formSize,
      onInput: p.onInputChange
    }), c({
      _: 2
      /* DYNAMIC */
    }, [
      e.$slots.prefix ? {
        name: "prefix",
        fn: n(() => [
          t(e.$slots, "prefix")
        ]),
        key: "0"
      } : void 0,
      e.$slots.suffix ? {
        name: "suffix",
        fn: n(() => [
          t(e.$slots, "suffix")
        ]),
        key: "1"
      } : void 0,
      e.$slots.prepend ? {
        name: "prepend",
        fn: n(() => [
          t(e.$slots, "prepend")
        ]),
        key: "2"
      } : void 0,
      e.$slots.append ? {
        name: "append",
        fn: n(() => [
          t(e.$slots, "append")
        ]),
        key: "3"
      } : void 0
    ]), 1040, ["value", "size", "onInput"])
  ]);
}
const z = /* @__PURE__ */ $(h, [["render", k], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/input/input.vue"]]), E = I(z);
export {
  E as default
};
